// Shared plain-text combined-transcript report builder for the IDI and Fusion
// "Download Transcripts" actions. Plain global, matching services/idi_generate_payment.js.

// `entityLines` are the entity-specific header lines (name, email, country, project/survey,
// generated). `noRecordingsLabel` / `noRecordingsTranscript` add the "No Recordings" section
// when a transcript exists.
globalThis.buildTranscriptReport = function (entityLines, noRecordingsLabel, noRecordingsTranscript, recordings) {
  const content = [
    '='.repeat(80),
    'COMBINED TRANSCRIPTS REPORT',
    '='.repeat(80),
    '',
    ...entityLines,
    `Total Recordings: ${recordings.length}`,
    ''
  ];

  if (noRecordingsTranscript?.trim()) {
    content.push(
      '-'.repeat(80),
      noRecordingsLabel,
      '-'.repeat(80),
      '',
      noRecordingsTranscript.trim(),
      ''
    );
  }

  const sortedRecordings = recordings.slice().sort((a, b) => {
    if (a.order_index != null && b.order_index != null) {
      return a.order_index - b.order_index;
    }
    return new Date(a.created_datetime) - new Date(b.created_datetime);
  });

  sortedRecordings.forEach((recording, index) => {
    content.push(
      '-'.repeat(80),
      `RECORDING ${index + 1}: ${recording.recording_name}`,
      '-'.repeat(80),
      '',
      `Recording ID: ${recording.id}`,
      `Upload Date: ${new Date(recording.recording_upload_datetime).toLocaleString()}`,
      `Has Recording: ${recording.has_recording ? 'Yes' : 'No'}`,
      `Has Transcript: ${recording.has_transcript ? 'Yes' : 'No'}`,
      `Last Updated: ${new Date(recording.last_updated_datetime).toLocaleString()}`,
      `Updated By: ${recording.last_updated_by_name || 'N/A'}`,
      ''
    );
    if (recording.transcript_content?.trim()) {
      content.push('TRANSCRIPT CONTENT:', '~'.repeat(40), recording.transcript_content.trim(), '');
    }
    if (recording.qa_questions?.trim()) {
      content.push('QUESTIONS:', '~'.repeat(40), recording.qa_questions.trim(), '');
    }
    if (recording.qa_transcripts?.trim()) {
      content.push('Q&A TRANSCRIPTS:', '~'.repeat(40), recording.qa_transcripts.trim(), '');
    }
    if (recording.summary?.trim()) {
      content.push('SUMMARY:', '~'.repeat(40), recording.summary.trim(), '');
    }
    if (!recording.transcript_content?.trim() && !recording.qa_questions?.trim()
      && !recording.qa_transcripts?.trim() && !recording.summary?.trim()) {
      content.push('No transcript content available for this recording.', '');
    }
    content.push('');
  });

  content.push('='.repeat(80), 'END OF REPORT', '='.repeat(80));
  return content.join('\n');
};
